module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-purchase/land-pur-agreements/lp-agreement-form/lp-agreement-form.component.css
// module id = ./src/app/landprocurement/land-purchase/land-pur-agreements/lp-agreement-form/lp-agreement-form.component.css
// module chunks = main